var map = {
	"./desktop-1.jpg": "b80c",
	"./desktop-2.jpg": "68d3",
	"./desktop-3.jpg": "f812",
	"./desktop-4.jpg": "39cb",
	"./desktop-5.jpg": "3d16",
	"./desktop-6.jpg": "508b",
	"./desktop-7.jpg": "befb",
	"./desktop-8.jpg": "45fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc0a";